// Michigan State's undergraduate majors (#2652). Read on 2026-10-01 from
// MSU Admissions' official program finder (Majors, degrees and programs,
// admissions.msu.edu): every program page whose level is "Undergraduate major" was read,
// grouped by the college the page names. A major MSU lists under two
// colleges (Lyman Briggs College and a partner college) appears in both
// groups. Left out: graduate programs, certificates, the exploratory
// preferences and the pre-professional preferences (Pre-Nursing, Predental,
// Premedical, Preoptometry, Preveterinary), which are not bachelor's majors.
// The program pages do not state a degree type, so degree is null. Names
// are MSU's own, capitalization included. The registrar's catalog
// (reg.msu.edu) refused automated reads on 2026-10-01. The KB's majors list
// was the starting point; the school's list wins.
const majors = {
    "slug": "michigan-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Michigan State University's official program finder, grouped by the college that offers it. Minors, certificates, pre-professional preferences and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture and Natural Resources",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Agribusiness Management",
                    "degree": null
                },
                {
                    "name": "Agriculture Food and Natural Resources Education",
                    "degree": null
                },
                {
                    "name": "Animal Science",
                    "degree": null
                },
                {
                    "name": "Applied Conservation Biology",
                    "degree": null
                },
                {
                    "name": "Aquatic Ecology and Management",
                    "degree": null
                },
                {
                    "name": "Construction Management",
                    "degree": null
                },
                {
                    "name": "Crop and Soil Sciences",
                    "degree": null
                },
                {
                    "name": "Cropping systems science",
                    "degree": null
                },
                {
                    "name": "Dietetics",
                    "degree": null
                },
                {
                    "name": "Entomology",
                    "degree": null
                },
                {
                    "name": "Environmental Economics and Management",
                    "degree": null
                },
                {
                    "name": "Environmental soil and water science",
                    "degree": null
                },
                {
                    "name": "Environmental Studies and Sustainability",
                    "degree": null
                },
                {
                    "name": "Fish Ecology and Management",
                    "degree": null
                },
                {
                    "name": "Food Industry Management",
                    "degree": null
                },
                {
                    "name": "Food Science",
                    "degree": null
                },
                {
                    "name": "Forestry",
                    "degree": null
                },
                {
                    "name": "Horticulture",
                    "degree": null
                },
                {
                    "name": "Interior Design",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Managerial economics for the bioeconomy",
                    "degree": null
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": null
                },
                {
                    "name": "Packaging",
                    "degree": null
                },
                {
                    "name": "Sustainable Parks, Recreation and Tourism",
                    "degree": null
                },
                {
                    "name": "Turfgrass science and management",
                    "degree": null
                },
                {
                    "name": "Urban and Regional Planning",
                    "degree": null
                },
                {
                    "name": "Wildlife Ecology and Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Arts and Letters",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "African American and African Studies",
                    "degree": null
                },
                {
                    "name": "Apparel and Textiles",
                    "degree": null
                },
                {
                    "name": "Arabic",
                    "degree": null
                },
                {
                    "name": "Art Education",
                    "degree": null
                },
                {
                    "name": "Art History and Visual Culture",
                    "degree": null
                },
                {
                    "name": "Arts and Humanities",
                    "degree": null
                },
                {
                    "name": "Arts and Humanities Health and Wellbeing",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Experience Architecture",
                    "degree": null
                },
                {
                    "name": "Film Studies",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "French Education",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "Global Studies in the Arts and Humanities",
                    "degree": null
                },
                {
                    "name": "Graphic Design",
                    "degree": null
                },
                {
                    "name": "Humanities - Prelaw",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Humanities",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null
                },
                {
                    "name": "Korean",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Nonprofit Leadership, Religion and Social Change",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy and law",
                    "degree": null
                },
                {
                    "name": "Philosophy and the sciences",
                    "degree": null
                },
                {
                    "name": "Professional and Public Writing",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Spanish Education",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Communication Arts and Sciences",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Advertising Creative",
                    "degree": null
                },
                {
                    "name": "Advertising Management",
                    "degree": null
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Communication Leadership and Strategy",
                    "degree": null
                },
                {
                    "name": "Communicative Sciences and Disorders",
                    "degree": null
                },
                {
                    "name": "Digital Storytelling",
                    "degree": null
                },
                {
                    "name": "Games and Interactive Media",
                    "degree": null
                },
                {
                    "name": "Information Science",
                    "degree": null
                },
                {
                    "name": "Journalism",
                    "degree": null
                },
                {
                    "name": "Public Relations",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "Kinesiology",
                    "degree": null
                },
                {
                    "name": "Special Education",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Applied Engineering Sciences",
                    "degree": null
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computational Data Science",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Technology Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Music",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Composition",
                    "degree": null
                },
                {
                    "name": "Jazz Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Music Education",
                    "degree": null
                },
                {
                    "name": "Music Performance",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Natural Science",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": null
                },
                {
                    "name": "Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": null
                },
                {
                    "name": "Biochemistry and Molecular Biology - Biotechnology",
                    "degree": null
                },
                {
                    "name": "Biomedical Laboratory Science",
                    "degree": null
                },
                {
                    "name": "Chemical Physics",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Computational and Applied Mathematics",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Earth and environmental sciences",
                    "degree": null
                },
                {
                    "name": "Environmental Biology - Microbiology",
                    "degree": null
                },
                {
                    "name": "Environmental Biology - Plant Biology",
                    "degree": null
                },
                {
                    "name": "Environmental Biology - Zoology",
                    "degree": null
                },
                {
                    "name": "Genetics and Genomics",
                    "degree": null
                },
                {
                    "name": "Human Biology",
                    "degree": null
                },
                {
                    "name": "Integrated Science - Secondary Education",
                    "degree": null
                },
                {
                    "name": "Integrative Biology",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Mathematics - Secondary Education",
                    "degree": null
                },
                {
                    "name": "Mathematics, Advanced",
                    "degree": null
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": null
                },
                {
                    "name": "Microbiology",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Physiology",
                    "degree": null
                },
                {
                    "name": "Plant Biology",
                    "degree": null
                },
                {
                    "name": "Quantitative Risk Analytics",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Zoology",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": null
                },
                {
                    "name": "Nursing (Online Program) - RN license required",
                    "degree": null
                },
                {
                    "name": "Nursing - Accelerated Second Degree Program",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Social Science",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Child Development and Early Education: Birth to Kindergarten and Special Education",
                    "degree": null
                },
                {
                    "name": "Criminal Justice",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Global and International Studies in Social Science",
                    "degree": null
                },
                {
                    "name": "Global History",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History: Social Studies Education",
                    "degree": null
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": null
                },
                {
                    "name": "Human resources and labor relations",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Studies in Social Science",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Political Science - Prelaw",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Public Policy",
                    "degree": null
                },
                {
                    "name": "Social Work",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "World Politics",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Veterinary Nursing",
                    "degree": null
                }
            ]
        },
        {
            "name": "Eli Broad College of Business",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Hospitality Business",
                    "degree": null
                },
                {
                    "name": "Human Resource Management",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Supply Chain Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "James Madison College",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "International Relations",
                    "degree": null
                },
                {
                    "name": "Political Theory and Constitutional Democracy",
                    "degree": null
                },
                {
                    "name": "Politics, rights and culture",
                    "degree": null
                },
                {
                    "name": "Public affairs for secondary education",
                    "degree": null
                },
                {
                    "name": "Social Relations and Policy",
                    "degree": null
                }
            ]
        },
        {
            "name": "Lyman Briggs College",
            "source": {
                "label": "MSU Admissions, Majors, degrees and programs",
                "url": "https://admissions.msu.edu/academics/majors-degrees-programs"
            },
            "majors": [
                {
                    "name": "Applied Conservation Biology",
                    "degree": null
                },
                {
                    "name": "Aquatic Ecology and Management",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Environmental Sciences and Management",
                    "degree": null
                },
                {
                    "name": "Food Science",
                    "degree": null
                },
                {
                    "name": "Integrated Science - Secondary Education",
                    "degree": null
                },
                {
                    "name": "Mathematics - Secondary Education",
                    "degree": null
                },
                {
                    "name": "Physical Science",
                    "degree": null
                },
                {
                    "name": "Science and Society",
                    "degree": null
                },
                {
                    "name": "Wildlife Ecology and Management",
                    "degree": null
                }
            ],
            "note": "Some Lyman Briggs College majors are also listed under the College of Agriculture and Natural Resources or the College of Natural Science."
        }
    ]
};

export default majors;
